import {createAsyncThunk} from "@reduxjs/toolkit";
import {
    getInvoiceById,
    updateInvoiceById,
} from "../../../api/finance/invoiceSearchApi";
import {saveJobEvInv} from "../../../api/finance/chargeConfirmation";

export const updateSingleInvEv = createAsyncThunk(
    "updateSingleInvEv",
    async (data) => {
        try {
            await updateInvoiceById(data);
            return await getInvoiceById(data.eihId);
        } catch (e) {
            console.error(e);
            throw e;
        }
    },
);

export const updateBulkInvEv = createAsyncThunk(
    "updateBulkInvEv",
    async (data) => {
        try {
            await updateInvoiceById(data);
            return await getInvoiceById(data.eihId);
        } catch (e) {
            console.error(e);
            throw e;
        }
    },
);

export const saveConsolidatedBulkInvEv = createAsyncThunk(
    "saveConsolidatedBulkInvEv",
    async (data, {rejectWithValue}) => {
        try {
            return await saveJobEvInv(data);
        } catch (e) {
            if (e.response && e.response.status === 409) {
                return rejectWithValue(e.response.data.message || "Duplicate records found.");
            }
            return rejectWithValue("An unexpected error occurred.");
        }
    },
);

export const savePlantWiseBulkInvEv = createAsyncThunk(
    "savePlantWiseBulkInvEv",
    async (data, {rejectWithValue}) => {
        try {
            return await saveJobEvInv(data);
        } catch (e) {
            if (e.response && e.response.status === 409) {
                return rejectWithValue(e.response.data.message || "Duplicate records found.");
            }
            return rejectWithValue("An unexpected error occurred.");
        }
    },
);

export const saveSingleInvEv = createAsyncThunk(
    "saveSingleInvEv",
    async (data, {rejectWithValue}) => {
        try {
            const response = await saveJobEvInv(data);
            return await getInvoiceById(response.eihId);
        } catch (e) {
            if (e.response && e.response.status === 409) {
                return rejectWithValue(e.response.data.message || "Duplicate records found.");
            }
            return rejectWithValue("An unexpected error occurred.");
        }
    },
);
